import PropTypes from 'prop-types';

import Heading from '../typography/heading';
import { divider, subheading } from './BlogIndexHeader.module.scss';

const categoryStrings = {
  national: [
    'National Issues',
    'These issues fall under the purview of Congress and/or the President.',
  ],
  resistbot: [
    'Resistbot Features and Releases',
    'Stay up-to-date on the newest bot features and our organization.',
  ],
  state: [
    'State Issues',
    'Your Governor and state legislators have the power here, engage with them to make a difference.',
  ],
  podcast: [
    'Resistbot Live',
    'Join us as we explore the issues that matter to the users of Resistbot and learn from the experts about why these issues are important to you too.',
  ],
};

const Header = ({ category, level = 'h2' }) => {
  const strings = categoryStrings[category];
  if (!strings) {
    return null;
  }

  const [heading, body] = strings;

  return (
    <div className={divider}>
      <Heading as={level} size="h2">
        {heading}
      </Heading>
      <div className={subheading}>{body}</div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  category: PropTypes.oneOf(['national', 'resistbot', 'state', 'podcast'])
    .isRequired,
};
